<template>
    <div class="field field--tags" :class="fieldClasses">
        <div class="row collapse no-pad align-middle" v-if="helptext || label">
            <div class="columns shrink" v-if="helptext">
                <help-text :helptext="helptext"></help-text>
            </div>
            <div class="columns" v-if="label">
                <label :class="labelClasses">{{ label }}</label>
            </div>
        </div>
        <div class="row">
            <div class="columns">
                <v-select
                    :value="value"
                    :multiple="true"
                    placeholder="Select Tags ..."
                    :push-tags="true"
                    :taggable="true"
                    :options="options"
                    :on-change="val => { $emit('updated', val) }">
                </v-select>
            </div>
        </div>
    </div>
</template>

<script>
    /**
     * Component Dependencies
     */
    import vSelect from 'vue-select'
    import BaseField from './BaseField'
    import HelpText from '../HelpText'
    import { fetchTags } from '../../../services/ProjectService'

    /**
     * Tags Component
     */
    export default {
        name: 'field_tags',
        extends: BaseField,
        components: {
            vSelect,
            HelpText
        },
        data: function () {
            return {
                options: []
            }
        },
        methods: {
            setTags: function (res) {
                this.options = res.data
            },
            failedToGetTags: function (err) {
                console.log(err)
            }
        },
        mounted: function () {
            fetchTags()
                .then(this.setTags)
                .catch(this.failedToGetTags)
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/general/forms/TagsField.vue